<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-alert type="info" color="blue darken-1">
          <span class="font-weight-bold">Preporuka: </span>
          Naziv odjela pisati u obliku npr. 2.a , II.a , 2.1 ili II.1
        </v-alert>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-alert type="info" color="red darken-1">
          <span class="font-weight-bold">Upozorenje: </span>
          Pripaziti pri odabiru nastavnog plana. Molimo vas da nakon kreiranja odjela prvo provjerite jesu li unešeni ispravni nastavni predmeti.
          U slučaju da postoji pogrešaka na nastavnom planu obratite se županijskom koordinatoru/SUMIT timu.
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-progress-linear
            :indeterminate="loading"
            height="4"
            style="padding:0; margin:0;"
          ></v-progress-linear>

          <v-container style="width: 90% !important;" class="my-10">
            <ValidationProvider
              :name="item.name"
              :rules="item.rules"
              mode="eager"
              ref="provider"
              v-bind:key="item.name"
              v-for="item in items"
            >
              <div slot-scope="{ errors }">
                <v-row no-gutters>
                  <!--Label for the form-->
                  <v-col
                    xs="12"
                    md="3"
                    style="height: 65px"
                    class="d-flex justify-end"
                  >
                    <div
                      class="d-flex align-center justify-end text-right mb-2"
                    >
                      <p
                        class="subtitle-3 font-weight-bold text--primary"
                        :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                      >
                        {{ item.title }}:
                      </p>
                    </div>
                  </v-col>

                  <!-- Text field -->
                  <v-col xs="12" md="9" style="height: 65px">
                    <v-text-field
                      dense
                      :name="item.name"
                      outlined
                      :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                      :prepend-icon="item.icon"
                      v-if="item.tag === 'input' && item.name != 'jmbg'"
                      v-model="form[item.name]"
                    >
                    </v-text-field>

                    <!-- Select field -->

                    <div v-if="item.tag === 'select'">
                      <v-autocomplete
                        outlined
                        dense
                        :placeholder="
                          item.rules && !resource.id ? 'Obavezno..' : ''
                        "
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        :item-text="item.text"
                        item-value="id"
                        :disabled="resource.id"
                        @input="selectedClass(item.name)"
                        v-if="item.name !== 'headroom_teacher_id'"
                        v-model="form[item.name]"
                      >
                      </v-autocomplete>

                      <!-- autocomplete za razrednika da pokazuje i eduID -->
                      <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        :item-text="item.text"
                        item-value="id"
                        v-else
                        v-model="form[item.name]"
                      >
                        <template slot="item" slot-scope="{ item }">
                          {{ item.full_name }} - {{ item.aai_email }}
                        </template>
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.full_name }} - {{ item.aai_email }}
                        </template>
                      </v-autocomplete>
                    </div>

                    <!-- Multiselect field -->

                    <v-autocomplete
                      outlined
                      dense
                      :placeholder="item.rules ? 'Obavezno..' : ''"
                      :items="item.source"
                      :name="item.name"
                      chips
                      multiple
                      v-if="item.tag === 'multiselect'"
                      v-model="form[item.name]"
                    >
                    </v-autocomplete>

                    <!-- HTML editor -->

                    <div style="height: 320px" v-if="item.tag === 'html'">
                      <br />

                      <span class="subheading"> {{ item.title }} <br /> </span>

                      <vue-editor
                        :name="item.name"
                        style="height: 200px; margin-top: 5px;"
                        v-model="form[item.name]"
                      >
                      </vue-editor>

                      <!--
                                            <p v-if="item.validate"
                                               class="form-error" style="padding: 10px;">
                                                Ovo polje je obavezno.
                                            </p>
                                            -->
                    </div>

                    <div
                      class="hidden-sm-and-up"
                      style="height: 60px;"
                      v-if="item.tag === 'html'"
                    ></div>
                  </v-col>
                </v-row>
              </div>
            </ValidationProvider>
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <div class="fix-element">
          <v-btn
            @click="saveResource()"
            color="primary"
            dark
            block
            width="100%"
          >
            Potvrdi
          </v-btn>

          <v-btn
            @click="goBack()"
            class="mt-4"
            color="primary"
            dark
            block
            outlined
          >
            Odustani
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { serverBus } from "../../main";

import { VueEditor } from "vue2-editor";

import { extend, setInteractionMode, ValidationProvider } from "vee-validate";
import { digits, email, max, min, required } from "vee-validate/dist/rules";
import ApiV2 from "../../services/ApiV2";

export default {
  components: {
    VueEditor,
    ValidationProvider,
  },

  props: ["customTable"],

  created: function() {
    setInteractionMode("eager");

    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", { ...required, message: "Ovo polje je obavezno." });

    this.table = "odjeljenje";
    this.resource.id = this.$route.params.resource_id;
    // console.log(this.resource.id)

    // this.getGeneralData();

    let self = this;
    serverBus.$on("perform-action-after-save", function() {
      self.$navigate("/admin/odjeljenje/pregled/" + self.id);
    });

    this.getResource();
    this.getResourceFormData();

    this.tableActive = this.table;
  },

  computed: {
    classes() {
      let classNames = [];
      switch (this.currentSchool.type) {
        case "Osnovna škola":
          classNames.push({ header: "Osnovna škola" });
          for (let i = 1; i <= 9; i++) {
            classNames.push({ id: i.toString(), text: `${i}. razred` });
          }
          break;
        case "Srednja škola":
          classNames.push({ header: "Srednja škola" });
          for (let i = 1; i <= 4; i++) {
            classNames.push({ id: (i + 10).toString(), text: `${i}. razred` });
          }
          break;
      }
      return classNames;
    },

    selectedField() {
      return this.$store.getters.getSchoolFieldId;
    },

    currentSchool() {
      return this.$store.getters.getSchool;
    },
  },

  methods: {
    saveItem() {
      serverBus.$emit("save-add-view-data");
    },

    selectedClass(inputName) {
      if (inputName === "school_class") {
        this.getSchoolPlans();
      }
    },

    getGeneralData() {
      this.$axios.post("odjeljenje/opcenito").then((response) => {
        this.breadcrumbs = response.data["breadcrumbs"];
        this.breadcrumbs.push({ text: "New item" });

        if (this.title === "") {
          this.title = response.data["title"];
        }
      });
    },

    getEduFields(item) {
      const schoolId = localStorage.getItem("school_id");

      ApiV2.get(`schools/${schoolId}/educationalFields`, {
        params: {
          perPage: -1,
        },
      })
        .then((response) => {
          item.source = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getSchoolPlans() {
      ApiV2.get(`school_educational_fields/${this.selectedField}/schoolPlans`, {
        params: {
          perPage: -1,
          filter: {
            school_class: this.form["school_class"],
          },
        },
      })
        .then((response) => {
          this.items[3].source = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getTeachers(item) {
      ApiV2.get(`users`, {
        params: {
          role: 6,
          perPage: -1,
        },
      }).then((response) => {
        item.source = response.data.data;
      });
    },
    async getSchoolYears(item) {

      let {data} = await ApiV2.get('school_years', {
        params: {
          sortBy: 'date_from',
          sortDesc: 1
        }
      })
      item.source = data.data;
      if (item.source.length>0){
        this.form['school_year_id']=item.source[0].id;
      }
    },

    getResourceFormData() {
      this.items.forEach((item) => {
        switch (item.name) {
          case "school_educational_field_id":
            this.getEduFields(item);
            break;
          case "school_year_id":
            this.getSchoolYears(item);
            break;
          case "school_plan_id":
            this.getSchoolPlans();
            break;
          case "school_class":
            item.source = this.classes;
            break;
          case "headroom_teacher_id":
            this.getTeachers(item);
            break;
        }
      });
    },

    getResource() {
      if (this.resource.id == null || this.resource.id === -1) return;

      ApiV2.get(`departments/${this.resource.id}`).then((response) => {
        this.form = response.data;
      });
    },

    saveResource() {
      this.form.school_educational_field_id = this.selectedField;

      if (this.resource.id == null || this.resource.id === -1) {
        this.createDepartment();
      } else {
        this.editDepartment();
      }
    },

    createDepartment() {
      ApiV2.post("departments", this.form)
        .then((response) => {
          serverBus.$emit("show-snackbar");
          this.id = response.data.id;

          this.form = {};

          serverBus.$emit("close-add-view-dialog");
          serverBus.$emit("perform-action-after-save");
        })
        .catch(function(error) {
          if (error.response.status == 422) {
            for (let key in error.response.data.errors) {
              serverBus.$emit(
                "show-snackbar",
                false,
                error.response.data.errors[key][0]
              );
            }
          } else {
            serverBus.$emit("show-snackbar", false);
          }
        })
        .finally(() => {
          serverBus.$emit("reload-all-data");

          this.loading = false;
        });
    },

    editDepartment() {
      ApiV2.put(`departments/${this.resource.id}`, this.form)
        .then((response) => {
          serverBus.$emit("show-snackbar");
          serverBus.$emit("close-add-view-dialog");

          this.id = response.data.id;

          serverBus.$emit("perform-action-after-save");
        })
        .catch(function(error) {
          if (error.response.status == 422) {
            for (let key in error.response.data.errors) {
              serverBus.$emit(
                "show-snackbar",
                false,
                error.response.data.errors[key][0]
              );
            }
          } else {
            serverBus.$emit("show-snackbar", false);
          }
        });
    },

    goBack() {
      this.$router.push("/admin/odjeljenje");
    },
  },

  beforeDestroy() {
    serverBus.$off("perform-action-after-save");
  },

  data: function() {
    return {
      dialog: false,
      loading: false,
      breadcrumbs: [],
      id: "",
      table: "",
      title: "",
      resource: {},
      form: {},
      roles: [],
      schools: [],
      cantons: [],
      roles_user: [],
      form_role: {},
      dropdownItems: [],
      jmbg: "",
      user: [],
      dropzones: true,
      tableActive: "",
      items: [
        {
          data: "label",
          name: "label",
          options: "",
          rules: "required",
          tag: "input",
          title: "Naziv odjela",
          type: "text",
        },
        {
          data: "school_year_id",
          name: "school_year_id",
          text: "title",
          value: "id",
          options: "",
          rules: "required",
          source: [],
          tag: "select",
          title: "Školska godina",
        },
        {
          data: "school_class",
          name: "school_class",
          text: "text",
          options: "",
          rules: "required",
          source: [],
          tag: "select",
          title: "Razred",
        },
        {
          data: "school_plan_id",
          name: "school_plan_id",
          text: "title",
          options: "",
          rules: "required",
          source: [],
          tag: "select",
          title: "Nastavni plan",
        },
        {
          data: "headroom_teacher_id",
          name: "headroom_teacher_id",
          text: "full_name",
          options: "",
          rules: "required",
          source: [],
          tag: "select",
          title: "Razrednik",
        },
      ],
      dzSingle: {
        url: "upload",
        method: "POST",
        maxFilesize: 20,
        maxFiles: 1,
        dictDefaultMessage: "Priložite datoteku..",
      },
      dzMulti: {
        url: "upload",
        method: "POST",
        maxFilesize: 20,
        dictDefaultMessage: "Priložite jednu ili više datoteka..",
      },
      //Date options
      date: new Date().toISOString().substr(0, 10),
      menu: false,
    };
  },
};
</script>

<style>
.fix-element {
  position: -webkit-sticky;
  position: sticky;
  top: 5rem;
  align-self: flex-start;
}
</style>
